// Max number of AI renders (rendered aiResults) a user can get. Once reached, the generate button
// (LookAIPopupGenerateButton) and the custom prompt regenerate button (AIResultCustomPrompt) open
// the limit box (LookAILimitBox) instead of starting a new render.
export const AI_RENDER_LIMIT = 5;

// aiResults starts out with empty placeholder slots (see aiReducer initialState), so only the
// entries that actually hold a rendered image are counted.
export const isAiRenderLimitReached = (aiResults: any[]): boolean =>
  (aiResults || []).filter(aiResult => aiResult && aiResult.resultImageUrl).length >= AI_RENDER_LIMIT;
